import React from 'react';
import { Link } from 'react-router-dom';
import './notfound.css';

function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">Page not found</h2>
        <p className="notfound-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="notfound-home-link">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;